import classNames     from 'classnames'
import React          from 'react'
import { withRouter } from 'react-router'

import { HorizontalForm                  } from 'alto-react-components/lib/components'
import { ChangePassword                  } from 'alto-react-base-auth/lib/components'
import { withAuthMessage                 } from 'alto-react-base-auth/lib/utils'
import { pinSetting                      } from 'alto-react-client-auth/lib/settings'
import { BadRequestError, ForbiddenError } from 'lib/errors'

class ChangePasswordPanel extends ChangePassword.WrappedComponent
  constructor: (props, context) ->
    super(props, context)

    @pin          = pinSetting(context.settings)
    @pinEnabled   = @pin.enabled and context.auth.isClient

    @state.pin    = ''

  panelClassName: ->
    classNames('auth-panel', right: @props.client)

  form: ->
    <HorizontalForm>
      {@currentPasswordInput()}
      {@newPasswordInput()}
      {@confirmationInput()}
      {@pinInput() if @pinEnabled}
      {@submitButton()}
    </HorizontalForm>

  pinInput: ->
    value  = @state.pin

    if value.length
      errors = @validatePin(@state.pin)
      valid  = not errors.length
      help   = errors.length and errors.map (error, index) -> <p key={index}>{error}</p>
    else
      valid = true
      help  = ''

    <HorizontalForm.Control id='pin' label='PIN' valid={valid} help={help} value={@state.pin}
     placeholder='Zadejte PIN pro jeho změnu, nebo ponechte prázdné'
     onChange={(value) => @setState(pin: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter' and @isValid()}
     {...@additionalPinInputProps()} />

  additionalPinInputProps: -> {}

  isValid: ->
    super() and \
      (not @pinEnabled or @isPinValid()) and \
      (@state.pin.length or @state.newPassword.length)

  isNewPasswordValid: ->
    (@pinEnabled and not @state.newPassword.length) or super()

  isPinValid: ->
    not @state.pin.length or not @validatePin(@state.pin).length

  validatePin: (pin) ->
    errors = []

    errors.push('Smí obsahovat pouze čísla')                unless /^\d+$/.test(pin)
    errors.push("Musí mít alespoň #{@pin.minLength} znaky") unless pin.length >= @pin.minLength

    errors

  submit: ->
    @context.auth.changePassword(@state.currentPassword, @state.newPassword, @state.pin)
      .then (response) =>
        whatChanged = if @state.newPassword.length then 'password' else 'pin'
        @props.history.push(withAuthMessage('/', "#{whatChanged}_change_successful", 'success'))
        null # otherwise runaway promise
      .catch BadRequestError, ForbiddenError, (error) =>
        @setState(errors: error.data)

export default withRouter(ChangePasswordPanel)
